import { render, staticRenderFns } from "./TaskActionCard.vue?vue&type=template&id=c2b699a4&"
import script from "./TaskActionCard.vue?vue&type=script&lang=js&"
export * from "./TaskActionCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskActionCard.vue?vue&type=style&index=0&id=c2b699a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports